<navbar class="mt-3" />
<section id="hero" class="hero section">
  <div class="hero-bg">
  </div>
  <div class="container text-center">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <h3 data-aos="fade-up" class="lh-sm green-color">
        
        <span class="green-color fs-3"> Start your Trust journey with us</span>
      </h3>
      <p data-aos="fade-up" data-aos-delay="100" class="text-white">
        Discover easy, secure, and professional solutions for creating and managing Trusts and Trust assets.<br>
        Let our experienced team help you set up the right Trust for your needs.
      </p>
      <div class="d-flex" data-aos="fade-up" data-aos-delay="200">
        <router-link 
          :to="{ path: '/prospective_applicant'}"
          class="btn btn-primary-dark btn-sm text-xs mt-3 p-2">
          Enquire Now
        </router-link>
      </div>
    </div>
  </div>
</section>
<AICampusFooter/>


